import { createAction } from 'redux-act';
// employee Request Pending action
const employeeRequestPendingRequest = createAction('EMPLOYEE_REQUEST_PENDING_REQUEST', data => data);
const employeeRequestPendingSuccess = createAction('EMPLOYEE_REQUEST_PENDING_SUCCESS', data => data);
const employeeRequestPendingError = createAction('EMPLOYEE_REQUEST_PENDING_ERROR');

// employee Correction Count action
const employeeCorrectionCountRequest = createAction('EMPLOYEE_CORRECTION_COUNT_REQUEST', data => data);
const employeeCorrectionCountSuccess = createAction('EMPLOYEE_CORRECTION_COUNT_SUCCESS', data => data);
const employeeCorrectionCountError = createAction('EMPLOYEE_CORRECTION_COUNT_ERROR');

// employee Weekly Attendance Trend action
const employeeWeeklyAttendanceTrendRequest = createAction('EMPLOYEE_WEEKLY_ATTENDANCE_REQUEST', data => data);
const employeeWeeklyAttendanceTrendSuccess = createAction('EMPLOYEE_WEEKLY_ATTENDANCE_SUCCESS', data => data);
const employeeWeeklyAttendanceTrendError = createAction('EMPLOYEE_WEEKLY_ATTENDANCE_ERROR');

// employee Attendance Statistics action
const employeeAttendanceStatisticsRequest = createAction('EMPLOYEE_ATTENDANCE_STATISTICS_REQUEST', data => data);
const employeeAttendanceStatisticsSuccess = createAction('EMPLOYEE_ATTENDANCE_STATISTICS_SUCCESS', data => data);
const employeeAttendanceStatisticsError = createAction('EMPLOYEE_ATTENDANCE_STATISTICS_ERROR');

//  employee Leaves Statistics action
const employeeLeavesStatisticsRequest = createAction('EMPLOYEE_LEAVE_STATISTICS_REQUEST', data => data);
const employeeLeavesStatisticsSuccess = createAction('EMPLOYEE_LEAVE_STATISTICS_SUCCESS', data => data);
const employeeLeavesStatisticsError = createAction('EMPLOYEE_LEAVE_STATISTICS_ERROR');

//  employee Leaves Statistics action
const getAnnouncementCountRequest = createAction('GET_ANNOUNCEMENT_COUNT_REQUEST', data => data);
const getAnnouncementCountSuccess = createAction('GET_ANNOUNCEMENT_COUNT_SUCCESS', data => data);
const getAnnouncementCountError = createAction('GET_ANNOUNCEMENT_COUNT_ERROR');

//  employee Attendance Count action
const employeeAttendanceCountRequest = createAction('EMPLOYEE_ATTENDANCE_COUNT_REQUEST', data => data);
const employeeAttendanceCountSuccess = createAction('EMPLOYEE_ATTENDANCE_COUNT_SUCCESS', data => data);
const employeeAttendanceCountError = createAction('EMPLOYEE_ATTENDANCE_COUNT_ERROR');

//  employee Attendance action
const employeeAttendanceRequest = createAction('EMPLOYEE_ATTENDANCE_REQUEST', data => data);
const employeeAttendanceSuccess = createAction('EMPLOYEE_ATTENDANCE_SUCCESS', data => data);
const employeeAttendanceError = createAction('EMPLOYEE_ATTENDANCE_ERROR');

//  employee Attendance Status action
const getEmployeeAttendanceStatusRequest = createAction('GET_EMPLOYEE_ATTENDANCE_STATUS_REQUEST', data => data);
const getEmployeeAttendanceStatusSuccess = createAction('GET_EMPLOYEE_ATTENDANCE_STATUS_SUCCESS', data => data);
const getEmployeeAttendanceStatusError = createAction('GET_EMPLOYEE_ATTENDANCE_STATUS_ERROR');

//  employee Attendance Status action
const employeeLeaveOrTimeOffRequest = createAction('EMPLOYEE_LEAVE_OR_TIME_OFF_REQUEST', data => data);
const employeeLeaveOrTimeOffSuccess = createAction('EMPLOYEE_LEAVE_OR_TIME_OFF_SUCCESS', data => data);
const employeeLeaveOrTimeOffError = createAction('EMPLOYEE_LEAVE_OR_TIME_OFF_ERROR');

const todayPresentEmployeeRequest = createAction('TODAY_PRESENT_EMPLOYEE_REQUEST', data => data);
const todayPresentEmployeeSuccess = createAction('TODAY_PRESENT_EMPLOYEE_SUCCESS', data => data);
const todayPresentEmployeeError = createAction('TODAY_PRESENT_EMPLOYEE_ERROR');


const moodMeter = createAction('MOOD_METER', data => data);
const pendingTask = createAction('PENDING_TASK', data => data);
const todayTask = createAction('TODAY_TASK', data => data);
const announcementModal = createAction('ANNOUNCEMENT', data => data);
const isShowAutoPopUp = createAction('IS_SHOW_AUTO_POPUP', data => data);
// clear existing Designation action
const handleClearDashboardStore = createAction('HANDLE_CLEAR_DASHBOARD_STORE', data => data);

export default {
    employeeRequestPendingRequest,
    employeeRequestPendingSuccess,
    employeeRequestPendingError,

    employeeCorrectionCountRequest,
    employeeCorrectionCountSuccess,
    employeeCorrectionCountError,

    employeeWeeklyAttendanceTrendRequest,
    employeeWeeklyAttendanceTrendSuccess,
    employeeWeeklyAttendanceTrendError,

    employeeAttendanceStatisticsRequest,
    employeeAttendanceStatisticsSuccess,
    employeeAttendanceStatisticsError,

    employeeLeavesStatisticsRequest,
    employeeLeavesStatisticsSuccess,
    employeeLeavesStatisticsError,

    getAnnouncementCountRequest,
    getAnnouncementCountSuccess,
    getAnnouncementCountError,

    employeeAttendanceCountRequest,
    employeeAttendanceCountSuccess,
    employeeAttendanceCountError,

    employeeAttendanceRequest,
    employeeAttendanceSuccess,
    employeeAttendanceError,

    getEmployeeAttendanceStatusRequest,
    getEmployeeAttendanceStatusSuccess,
    getEmployeeAttendanceStatusError,

    employeeLeaveOrTimeOffRequest,
    employeeLeaveOrTimeOffSuccess,
    employeeLeaveOrTimeOffError,

    todayPresentEmployeeRequest,
    todayPresentEmployeeSuccess,
    todayPresentEmployeeError,

    moodMeter,
    pendingTask,
    todayTask,
    announcementModal,
    isShowAutoPopUp,

    handleClearDashboardStore,

}